import css from './link.module.scss';
import {LinkProps} from './link.types';

export const Link = ({children, onClick}: LinkProps): JSX.Element => {
	return (
		<div onClick={onClick} className={css.container}>
			{children}
		</div>
	);
};
